// UserPrivileges
export const UserPrivileges = {
    ACCOUNTINGSOFTWARE_MANAGE: "accountingsoftware_manage",
    APP: 'app',
    APP_MODIFY_STOCK_PICKING: 'app_modify_stock_picking',
    BACKOFFICE_GENERAL: "backoffice_general",
    BOL_MANAGE: "bol_manage",
    AMAZON_MANAGE: "amazon_manage",
    CARRIER_MANAGE: "carrier_manage",
    COST_READ: "cost_read",
    COST_MANAGE: "cost_manage",
    COUNTINGSTRATEGY_READ: "countingstrategy_read",
    EXTERNALCHANNELS_MANAGE: "externalchannels_manage",
    COUNTINGSTRATEGY_MANAGE: "countingstrategy_manage",
    COUNTINGSTRATEGYTEMPLATE_MANAGE: "countingstrategytemplate_manage",
    IMPORT_MANAGE: "import_manage",
    INBOUND_READ: "inbound_read",
    INBOUND_MANAGE: "inbound_manage",
    INBOUND_PROCESS_PC: "inbound_process_pc",
    INVOICECATEGORY_READ: "invoicecategory_read",
    INVOICECATEGORY_MANAGE: "invoicecategory_manage",
    INVOICEPRODUCT_MANAGE: "invoiceproduct_manage",
    INVOICEPRODUCT_READ: "invoiceproduct_read",
    INVOICE_MANAGE: "invoice_manage",
    INVOICE_READ: "invoice_read",
    INVOICE_CONCEPTPRODUCT_MANAGE:"invoice_conceptproduct_manage",
    INVOICE_ORDERSWITHOUTCOST_MANAGE:"invoice_orderswithoutcost_manage",
    ECHECK: "echeck",
    ECHECK_CLICK_ALL_PRODUCTS: 'echeck_click_all_products',
    ECHECK_PRINT_BULK_LABELS: 'echeck_print_bulk_labels',
    ECHECK_SKIP_AMOUNT_CHECK: 'echeck_skip_amount_check',
    ECHECK_FINALIZE_WITHOUT_LABEL: 'echeck_finalize_without_label',
    FEEDBACK_MANAGE: "feedback_manage",
    NEWS_POPUP_READ: "news_popup_read",
    NOTIFICATION_READ: "notification_read",
    NOTIFICATION_ORDER_ACTION_REQUIRED: "notification_order_action_required",
    NOTIFICATION_ORDER_NO_PICKSTREAM: "notification_order_no_pickstream",
    NOTIFICATION_STOCK_BELOW_SAFETY: "notification_stock_below_safety",
    NOTIFICATION_INVOICE_REMINDER: "notification_invoice_reminder",
    NOTIFICATION_ORDER_IN_BACKORDER: "notification_order_in_backorder",
    NOTIFICATION_ORDER_IN_MAINTENANCE: "notification_order_in_maintenance",
    NOTIFICATION_ORDER_NOT_IMPORTED: "notification_order_not_imported",
    NOTIFICATION_STOCK_LOW: "notification_stock_low",
    NOTIFICATION_INBOUND_COMPLETED: "notification_inbound_completed",
    NOTIFICATION_EXPORT_READY: "notification_export_ready",
    NOTIFICATION_WEBSHOP_APPROVAL_REQUIRED: "notification_webshop_approval_required",
    NOTIFICATION_RETURN_SHIPMENT_FAILED: "notification_return_shipment_failed",
    NOTIFICATION_ORDER_MULTIPLE_STATE_OPEN_CHANGES: "notification_order_multiple_state_open_changes",
    NOTIFICATION_SUPPORT_TICKET_CREATED: "notification_support_ticket_created",
    NOTIFICATION_SUPPORT_TICKET_REPLY: "notification_support_ticket_reply",
    NOTIFICATION_SUPPORT_TICKET_ASSIGNED: "notification_support_ticket_assigned",
    OUTBOUND_READ: "outbound_read",
    OUTBOUND_MANAGE: "outbound_manage",
    OUTBOUND_MODIFY_WEBSHOPREFERENCE: "outbound_modify_webshopreference",
    OUTBOUND_MODIFY_SHIPPED_STATE: "outbound_modify_shipped_state",
    OUTBOUND_CANCEL_PICKED: "outbound_cancel_picked",
    OUTBOUND_ORDER_TO_SHIPPED: 'outbound_order_to_shipped',
    OUTBOUND_ORDER_VALUE:"outbound_order_value",
    OUTBOUND_MANAGE_PRELOAD_SHIPMENTS: 'outbound_manage_preload_shipments',
    ORDER_DROPSHIP_SKIPCHECK: 'order_dropship_skipcheck',
    PALLETSPOT_READ: "palletspot_read",
    PICKINGJOB_BULK_ACTION: "pickingjob_bulk_action",
    PICKINGJOB_MANAGE: "pickingjob_manage",
    PICKINGJOB_READ: "pickingjob_read",
    PICKINGRESOURCE_MANAGE: "pickingresource_manage",
    PICKINGRESOURCE_READ: "pickingresource_read",
    PRICEINCREASE_MANAGE: "priceincrease_manage",
    PRICEINCREASE_READ: "priceincrease_read",
    PRODUCT_IMPORT: "product_import",
    PRODUCT_MANAGE: "product_manage",
    PRODUCT_MANAGE_RELATION: "product_manage_relation",
    PRODUCT_READ: "product_read",
    PRODUCTFIELD_MANAGE: "productfield_manage",
    RELATION_MANAGE: "relation_manage",
    RELATION_READ: "relation_read",
    REPLENISHLINE_MANAGE: "replenishline_manage",
    REPLENISHLINE_READ: "replenishline_read",
    RETURN_READ: "return_read",
    RETURN_MANAGE: "return_manage",
    RETURN_PORTAL: "return_portal",
    REPLENISH: "replenish",
    RP_ACCESS_READ: "rp_access_read",
    RP_ACCESS_MANAGE: "rp_access_manage",
    RP_IMPORT_MANAGE: "rp_import_manage",
    RP_INBOUND_READ: "rp_inbound_read",
    RP_INBOUND_MANAGE: "rp_inbound_manage",
    RP_INVOICE_READ: "rp_invoice_read",
    RP_ORDER_READ: "rp_order_read",
    RP_ORDER_MANAGE: "rp_order_manage",
    RP_PRODUCT_IMPORT: "rp_product_import",
    RP_PRODUCT_READ: "rp_product_read",
    RP_PRODUCT_MANAGE: "rp_product_manage",
    RP_RETURN_READ: "rp_return_read",
    RP_RETURN_MANAGE: "rp_return_manage",
    RP_RETURN_PORTAL: "rp_return_portal",
    RP_SUPPLIER_READ: "rp_supplier_read",
    RP_SUPPLIER_MANAGE: "rp_supplier_manage",
    RP_USER_MANAGE: "rp_user_manage",
    RP_USER_READ: "rp_user_read",
    RP_USERGROUP_MANAGE: "rp_usergroup_manage",
    RP_USERGROUP_READ: "rp_usergroup_read",
    RP_WEBSHOPCREDENTIALS_MANAGE: "rp_webshopcredentials_manage",
    RP_COMPANY_INFO_READ:"rp_company_info_read",
    RP_COMPANY_INFO_MANAGE:"rp_company_info_manage",
    RP_EXTERNALCHANNELS_MANAGE: "rp_externalchannels_manage",
    RP_SUPPORT_READ: "rp_support_read",
    RP_SUPPORT_MANAGE: "rp_support_manage",
    SETTINGS_ALL: "settings_all",
    SETTINGS_GENERAL: "settings_general",
    SETTINGS_MENU: "settings_menu",
    SETTINGS_USERS: "settings_users",
    SETTINGS_USERPRIVILEGES: "settings_userprivileges",
    SHIPPER_MANAGE: "shipper_manage",
    SHIPPER_READ: "shipper_read",
    STOCK_READ: "stock_read",
    STOCK_MANAGE: "stock_manage",
    STOCK_TRANSFER: "stock_transfer",
    SUPPORT_READ: "support_read",
    SUPPORT_MANAGE: "support_manage",
    SUPPORT_SETTINGS: "support_settings",
    STREAM_MANAGE: "stream_manage",
    STREAM_READ: "stream_read",
    SUPPLIER_READ: "supplier_read",
    SUPPLIER_MANAGE: "supplier_manage",
    WAREHOUSE_READ: "warehouse_read",
    WAREHOUSE_MANAGE: "warehouse_manage",
    WAREHOUSELOCATION_READ: "warehouselocation_read",
    WAREHOUSELOCATION_MANAGE: "warehouselocation_manage",
    WEBSHOPCREDENTIALS_RELATION: "webshopcredentials_relation",
    WEBSHOPCREDENTIALS_MANAGE: "webshopcredentials_manage",
    PRINTER_MANAGE: "printer_manage",
    PRINTER_READ: "printer_read",
    WORKFLOW_MANAGE: "workflow_manage",
    WORKFLOW_READ: "workflow_read",
    WORKFLOWTEMPLATE_MANAGE: "workflowtemplate_manage",
    WORKFLOWTEMPLATE_READ: "workflowtemplate_read",
    WORKSPACE_MANAGE: "workspace_manage",
    WORKSPACE_READ: "workspace_read",
    REPORT_READ: "report_read",
    DASHBOARD_READ:"dashboard_read",
    ORDERS_PAGE_READ: "orders_page_read",
    BATCHES_PAGE_READ: "batches_page_read",
    INBOUNDS_PAGE_READ:"inbounds_page_read",
    RETURNS_PAGE_READ:"returns_page_read",
    PRODUCTS_PAGE_READ:"products_page_read",
    RELATIONS_PAGE_READ:"relations_page_read",
    CHANNELS_PAGE_READ:"channels_page_read",
    STOCK_PAGE_READ:"stock_page_read",
    WAREHOUSELOCATIONS_PAGE_READ:"warehouselocations_page_read",
    REPLENISH_PAGE_READ:"replenish_page_read",
    COUNTINGASSIGNMENT_PAGE_READ: "countingassignment_page_read",
    INVOICE_PAGE_READ:"invoice_page_read",
    INVOICEPARTS_PAGE_READ:"invoiceparts_page_read",
    INBOUNDPROCESSING_PAGE_READ:"inboundprocessing_page_read",
    RETURNSPROCESSING_PAGE_READ:"returnsprocessing_page_read",
    SENDING_CLICK_TO_SCAN:"sending_click_to_scan",
    ALLOW_SET_CUSTOM_CARRIER_SHIPPER:"allow_set_custom_carrier_shipper",
    BARCODE_PRINT:"barcode_print",

    SUPPORT_READ: "support_read",
    SUPPORT_MANAGE: "support_manage",
    SUPPORT_SETTINGS: "support_settings",
    RP_SUPPORT_READ: "rp_support_read",
    RP_SUPPORT_MANAGE: "rp_support_manage"
};